/* ============================================================
   NYM guided funnels engine — Suit Finder / Wedding / Custom.
   - Dialogs are closed on load; open ONLY from explicit triggers:
     [data-nym-action="…"] or links ending in #find-my-suit /
     #plan-my-wedding / #build-custom-suit (admin menu links).
   - No PII ever enters analytics events.
   ============================================================ */
(function () {
  'use strict';

  var HASH_ACTIONS = {
    'find-my-suit': 'suit-finder',
    'plan-my-wedding': 'wedding-funnel',
    'build-custom-suit': 'custom-funnel'
  };

  var registry = {};

  function track(name, params) {
    if (window.NYMAnalytics) return window.NYMAnalytics.track(name, params);
    window.dataLayer = window.dataLayer || [];
    var p = { event: name };
    for (var k in params) p[k] = params[k];
    window.dataLayer.push(p);
  }

  function money(cents) {
    var v = (cents / 100).toFixed(2);
    return '$' + (v.slice(-3) === '.00' ? v.slice(0, -3) : v);
  }

  /* ---------- controller ---------- */

  function Funnel(dialog) {
    this.dialog = dialog;
    this.action = dialog.getAttribute('data-nym-funnel');
    this.prefix = this.action.replace(/-/g, '_');
    this.steps = [].slice.call(dialog.querySelectorAll('.nym-funnel__step'));
    this.results = dialog.querySelector('.nym-funnel__results');
    this.bar = dialog.querySelector('.nym-funnel__bar-fill');
    this.count = dialog.querySelector('.nym-funnel__count');
    this.backBtn = dialog.querySelector('.nym-funnel__back');
    this.nextBtn = dialog.querySelector('.nym-funnel__next');
    this.state = {};
    this.index = 0;
    this.onResults = false;
    this.trigger = null;
    this.bind();
  }

  Funnel.prototype.bind = function () {
    var self = this;

    this.dialog.addEventListener('click', function (e) {
      if (e.target === self.dialog) return self.close();

      var opt = e.target.closest('.nym-funnel-option');
      if (opt) return self.choose(opt);

      if (e.target.closest('.nym-funnel__close')) return self.close();
      if (e.target.closest('.nym-funnel__back')) return self.back();
      if (e.target.closest('.nym-funnel__next')) return self.advance();

      var lead = e.target.closest('[data-nym-lead-toggle]');
      if (lead) {
        var panel = self.dialog.querySelector('[data-nym-lead]');
        if (panel) {
          panel.hidden = false;
          lead.hidden = true;
          var first = panel.querySelector('input');
          if (first) first.focus();
        }
        return;
      }

      var trackEl = e.target.closest('[data-nym-event]');
      if (trackEl) track(trackEl.getAttribute('data-nym-event'), { funnel: self.action });
    });

    this.dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('nym-funnel-open');
      if (self.trigger && document.contains(self.trigger)) self.trigger.focus();
    });

    var form = this.dialog.querySelector('form[data-nym-lead-form]');
    if (form) {
      form.addEventListener('submit', function () {
        var note = form.querySelector('[data-nym-lead-note]');
        if (note) note.value = self.summaryText();
        track('wedding_lead', { party_size: self.state.party || '', wedding_style: self.state.style || '' });
      });
    }
  };

  Funnel.prototype.visibleSteps = function () {
    var state = this.state;
    return this.steps.filter(function (step) {
      var cond = step.getAttribute('data-step-if');
      if (!cond) return true;
      var kv = cond.split(':');
      return kv[1].split(',').indexOf(state[kv[0]]) !== -1;
    });
  };

  Funnel.prototype.open = function (trigger) {
    this.trigger = trigger || null;
    if (typeof this.dialog.showModal !== 'function') return;
    if (this.dialog.open) return;
    this.dialog.showModal();
    document.documentElement.classList.add('nym-funnel-open');
    this.index = 0;
    this.onResults = false;
    this.render();
    track(this.prefix + '_started', {});
  };

  Funnel.prototype.close = function () {
    if (this.dialog.open) this.dialog.close();
  };

  Funnel.prototype.choose = function (btn) {
    this.state[btn.getAttribute('data-key')] = btn.getAttribute('data-value');
    var group = btn.closest('.nym-funnel__options');
    [].slice.call(group.querySelectorAll('.nym-funnel-option')).forEach(function (b) {
      b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
    });
    var self = this;
    window.setTimeout(function () { self.advance(); }, 160);
  };

  Funnel.prototype.advance = function () {
    var visible = this.visibleSteps();
    var step = visible[this.index];

    if (step) {
      var input = step.querySelector('[data-nym-input]');
      var error = step.querySelector('.nym-funnel__error');
      if (input) {
        if (input.required && !input.value) {
          if (error) error.hidden = false;
          input.focus();
          return;
        }
        if (error) error.hidden = true;
        this.state[input.getAttribute('data-nym-input')] = input.value;
      }
    }

    if (this.index < visible.length - 1) {
      this.index += 1;
      this.render();
      track(this.prefix + '_step', { step: this.index + 1, name: visible[this.index].getAttribute('data-step') });
    } else {
      this.finish();
    }
  };

  Funnel.prototype.back = function () {
    if (this.onResults) {
      this.onResults = false;
      this.index = this.visibleSteps().length - 1;
    } else if (this.index > 0) {
      this.index -= 1;
    }
    this.render();
  };

  Funnel.prototype.render = function () {
    var visible = this.visibleSteps();

    this.steps.forEach(function (s) { s.hidden = true; });
    if (this.results) this.results.hidden = true;

    if (this.onResults) {
      if (this.results) this.results.hidden = false;
      if (this.bar) this.bar.style.width = '100%';
      if (this.count) this.count.textContent = '';
      if (this.backBtn) this.backBtn.hidden = false;
      if (this.nextBtn) this.nextBtn.hidden = true;
      var rt = this.results && this.results.querySelector('.nym-funnel__results-title');
      if (rt) rt.focus();
      return;
    }

    var step = visible[this.index];
    if (!step) return;
    step.hidden = false;

    if (this.bar) this.bar.style.width = ((this.index + 1) / (visible.length + 1)) * 100 + '%';
    if (this.count) this.count.textContent = 'Step ' + (this.index + 1) + ' of ' + visible.length;
    if (this.backBtn) this.backBtn.hidden = this.index === 0;
    if (this.nextBtn) this.nextBtn.hidden = !step.hasAttribute('data-step-manual');

    window.requestAnimationFrame(function () {
      var q = step.querySelector('.nym-funnel__question');
      if (q) q.focus();
    });
  };

  Funnel.prototype.finish = function () {
    if (this.action === 'suit-finder') this.finishSuitFinder();
    else if (this.action === 'wedding-funnel') this.finishWedding();
    else this.finishCustom();
    this.onResults = true;
    this.render();
    track(this.prefix + '_completed', {});
  };

  Funnel.prototype.labelFor = function (key) {
    var btn = this.dialog.querySelector('.nym-funnel-option[data-key="' + key + '"][data-value="' + this.state[key] + '"]');
    if (btn) {
      var strong = btn.querySelector('strong');
      return (strong ? strong.textContent : btn.textContent).trim().split('\n')[0];
    }
    return this.state[key] || '';
  };

  Funnel.prototype.summaryText = function () {
    var self = this;
    return Object.keys(this.state).map(function (k) { return k + ': ' + self.state[k]; }).join(' | ');
  };

  /* ---------- Suit Finder scoring (weights from design.md §11) ---------- */

  var BUDGET_BANDS = {
    'under-250': [0, 25000],
    '250-450': [25000, 45000],
    '450-700': [45000, 70000],
    '700-plus': [70000, Infinity]
  };

  Funnel.prototype.products = function () {
    if (this._products) return this._products;
    var el = this.dialog.querySelector('[data-nym-products]');
    try {
      this._products = el ? JSON.parse(el.textContent) : [];
    } catch (e) {
      this._products = [];
    }
    return this._products;
  };

  Funnel.prototype.score = function (p) {
    var s = this.state;
    var score = 0;

    if (p.occasions && p.occasions.length) {
      if (p.occasions.indexOf(s.occasion) !== -1) score += 30;
    } else {
      score += 8;
    }

    if (p.fits && p.fits.length) {
      if (p.fits.indexOf(s.fit) !== -1 || s.fit === 'any') score += 20;
    } else {
      score += 6;
    }

    if (p.colors && p.colors.length) {
      if (p.colors.indexOf(s.color) !== -1) score += 15;
    } else {
      score += 4;
    }

    var band = BUDGET_BANDS[s.budget];
    if (band && typeof p.price === 'number') {
      if (p.price >= band[0] && p.price < band[1]) score += 15;
      else if (p.price >= band[0] * 0.8 && p.price < band[1] * 1.2) score += 6;
    }

    score += 10; /* feed only contains purchasable products */

    var formalOccasion = ['wedding', 'black-tie', 'prom'].indexOf(s.occasion) !== -1;
    if (formalOccasion && p.formal) score += 10;
    if (!formalOccasion && !p.formal) score += 10;

    return score;
  };

  Funnel.prototype.finishSuitFinder = function () {
    var self = this;
    var scored = this.products()
      .map(function (p) { return { p: p, score: self.score(p) }; })
      .sort(function (a, b) { return b.score - a.score || a.p.price - b.p.price; });

    var grid = this.results.querySelector('.nym-rec-grid');
    var tmpl = this.dialog.querySelector('[data-nym-rec-template]');
    grid.innerHTML = '';

    if (!scored.length || !tmpl) {
      var sub = this.results.querySelector('.nym-funnel__results-sub');
      if (sub) sub.textContent = 'We could not load recommendations right now — browse all suits below or visit a store for a fitting.';
      return;
    }

    var best = scored[0];
    var alt = scored.slice(1).filter(function (x) {
      return x.p.colors.join() !== best.p.colors.join() || x.p.fits.join() !== best.p.fits.join();
    })[0] || scored[1];
    var pool = scored.slice(0, 10).filter(function (x) { return x !== best && x !== alt; });
    var premium = pool.sort(function (a, b) { return b.p.price - a.p.price; })[0];

    var tiers = [
      { label: 'Best Match', item: best, cls: 'nym-rec--best' },
      { label: 'Alternative', item: alt, cls: '' },
      { label: 'Premium Choice', item: premium, cls: '' }
    ];

    var ids = [];
    tiers.forEach(function (tier) {
      if (!tier.item) return;
      var p = tier.item.p;
      ids.push(p.id);
      var node = tmpl.content.firstElementChild.cloneNode(true);
      if (tier.cls) node.classList.add(tier.cls);
      node.querySelector('.nym-rec__tier').textContent = tier.label;
      var img = node.querySelector('img');
      if (p.image) { img.src = p.image; img.alt = p.title; } else { img.remove(); }
      node.querySelector('.nym-rec__title-text').textContent = p.title;
      node.querySelector('.nym-rec__price').textContent = money(p.price);
      var link = node.querySelector('a.nym-textlink');
      link.href = p.url;
      link.addEventListener('click', function () { track('recommended_product_click', { product_id: p.id }); });
      grid.appendChild(node);
    });

    track('recommended_product_view', { product_ids: ids.join(',') });

    var subEl = this.results.querySelector('.nym-funnel__results-sub');
    if (subEl && best.score < 45) {
      subEl.textContent = 'Closest matches based on what is in stock today — for a perfect fit, our stylists can help in store.';
    }
  };

  /* ---------- Wedding Style Plan ---------- */

  var GROOM_LOOKS = {
    'black-tie': 'Tuxedo — black or midnight blue, peak lapel, bow tie',
    'formal': 'Three-piece suit with waistcoat',
    'modern': 'Slim-cut two-piece suit, clean lines',
    'destination': 'Lightweight suit in a lighter tone, unstructured',
    'summer': 'Breathable light-tone suit, open weave'
  };

  Funnel.prototype.finishWedding = function () {
    var s = this.state;
    var plan = this.results.querySelector('[data-nym-plan]');
    if (plan) {
      var color = this.labelFor('color') || 'your chosen color';
      var groom = GROOM_LOOKS[s.style] || 'Tailored suit';
      if (s.style !== 'black-tie') groom += ' in ' + color.toLowerCase();

      var items = [
        ['The Groom', groom],
        ['Wedding Party', s.party === '1' ? 'Solo fitting — groom focus' : 'Coordinated ' + color.toLowerCase() + ' looks, one shade lighter or matching'],
        ['Accessories', s.style === 'black-tie' ? 'Bow tie, studs, patent shoes' : 'Coordinated ties and pocket squares'],
        ['Color Direction', color],
        ['Timing', s.weddingDate ? 'Wedding date: ' + s.weddingDate + ' — fittings 6–8 weeks ahead recommended' : 'Book fittings 6–8 weeks ahead'],
        ['Next Step', (s.party === '5-8' || s.party === '9-plus') ? 'Group consultation at your preferred store' : 'Consultation or shop the look online']
      ];
      plan.innerHTML = items.map(function (it) {
        return '<div class="nym-plan__item"><span class="nym-plan__label">' + it[0] + '</span><span class="nym-plan__value"></span></div>';
      }).join('');
      [].slice.call(plan.querySelectorAll('.nym-plan__value')).forEach(function (el, i) { el.textContent = items[i][1]; });
    }

    var shopCta = this.results.querySelector('[data-nym-cta="shop-wedding"]');
    var bigParty = s.party === '5-8' || s.party === '9-plus';
    if (shopCta) {
      shopCta.className = bigParty ? 'nym-textlink' : 'nym-btn nym-btn--outline';
    }
  };

  /* ---------- Custom Suit Profile ---------- */

  Funnel.prototype.finishCustom = function () {
    var plan = this.results.querySelector('[data-nym-plan]');
    if (!plan) return;
    var self = this;
    var rows = [
      ['Occasion', 'occasion'], ['Garment', 'garment'], ['Fit', 'fit'],
      ['Fabric', 'fabric'], ['Style', 'style'], ['Budget', 'budget'],
      ['Timeline', 'timeline'], ['Preferred Store', 'store']
    ].filter(function (r) { return self.state[r[1]]; });

    plan.innerHTML = rows.map(function () {
      return '<div class="nym-plan__item"><span class="nym-plan__label"></span><span class="nym-plan__value"></span></div>';
    }).join('');
    [].slice.call(plan.querySelectorAll('.nym-plan__item')).forEach(function (el, i) {
      el.querySelector('.nym-plan__label').textContent = rows[i][0];
      el.querySelector('.nym-plan__value').textContent = self.labelFor(rows[i][1]);
    });

    var store = this.state.store;
    [].slice.call(this.results.querySelectorAll('[data-nym-store]')).forEach(function (a) {
      var match = a.getAttribute('data-nym-store') === store;
      a.classList.toggle('nym-btn--service', match || !store || store === 'either');
      a.classList.toggle('nym-btn--outline', !!store && store !== 'either' && !match);
    });
  };

  /* ---------- registry + intent-only triggers ---------- */

  function init() {
    [].slice.call(document.querySelectorAll('dialog[data-nym-funnel]')).forEach(function (d) {
      var key = d.getAttribute('data-nym-funnel');
      if (!registry[key] || registry[key].dialog !== d) registry[key] = new Funnel(d);
    });
  }

  document.addEventListener('click', function (event) {
    var el = event.target.closest('[data-nym-action], a[href*="#find-my-suit"], a[href*="#plan-my-wedding"], a[href*="#build-custom-suit"]');
    if (!el) return;

    var action = el.getAttribute('data-nym-action');
    if (!action && el.href) {
      action = HASH_ACTIONS[(el.href.split('#')[1] || '').toLowerCase()];
    }
    if (!action) return;

    var funnel = registry[action];
    if (!funnel) return; /* section not on this page: allow default navigation */

    event.preventDefault();
    funnel.open(el);
  });

  /* Lead-capture adapter boundary (plan.md Task 7 Step 6). */
  window.NYMLeadCapture = window.NYMLeadCapture || {
    submitWeddingLead: function () {
      var form = document.querySelector('form[data-nym-lead-form]');
      if (!form) return false;
      form.submit();
      return true;
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
